import { graphql } from '../../graphql';

export const getCategoryAdditionalParameters = graphql(`
  query CategoryAdditionalParameters($categoryId: ID!) {
    additionalParameters(categoryId: $categoryId) {
      id
      name
      iconUrl
    }
  }
`);
